
import { Interview } from "@/types/interview";

export const mockInterviews: Interview[] = [
  {
    id: "1",
    freelancer: "Sarah Chen",
    date: "2024-03-20",
    time: "10:00 AM",
    status: "pending",
    type: "video",
    duration: "45 mins",
    project: "UI/UX Redesign",
    platform: "Zoom",
    notes: "Discuss portfolio and previous experience in UI/UX projects"
  },
  {
    id: "2",
    freelancer: "Michael Roberts",
    date: "2024-03-21",
    time: "2:30 PM",
    status: "accepted",
    type: "chat",
    duration: "30 mins",
    project: "Smart Contract Audit",
    platform: "Discord",
    notes: "Technical assessment and code review discussion"
  },
  {
    id: "3",
    freelancer: "Alex Thompson",
    date: "2024-03-19",
    time: "11:00 AM",
    status: "completed",
    type: "video",
    duration: "60 mins",
    project: "Web3 DApp Development",
    platform: "Google Meet",
    notes: "Final round interview focusing on blockchain expertise"
  },
  {
    id: "4",
    freelancer: "Emma Wilson",
    date: "2024-03-22",
    time: "4:00 PM",
    status: "pending",
    type: "video",
    duration: "45 mins",
    project: "Mobile App Development",
    platform: "Zoom",
    notes: "Initial screening and technical discussion"
  }
];
